// Login + register panel. Visible only when phase = "need_auth".

import type { Net } from "../net.js";

export function renderLoginPanel(host: HTMLElement, net: Net): void {
  host.innerHTML = `
    <div class="panel-card">
      <h2>Hammer of Order</h2>
      <p class="dim">Step into Malloria, 1486. Choose your side: the inquisitor's hammer, or the witch's pact.</p>

      <form id="auth-form" autocomplete="off">
        <label>Username <input id="u" name="u" type="text" required minlength="3" maxlength="24" pattern="[a-zA-Z0-9_]+" title="Letters, numbers, and underscores only" /></label>
        <label>Password <input id="p" name="p" type="password" required minlength="8" maxlength="128" /></label>
        <label id="confirm-row" style="display:none">Confirm Password <input id="pc" name="pc" type="password" required minlength="8" maxlength="128" /></label>
        <label class="dim">Email (optional, for recovery) <input id="e" name="e" type="email" /></label>
        <p id="pw-policy" class="dim" style="display:none;font-size:0.8em;margin:0.3em 0">
          Min 8 characters. Must include at least one letter and one number or symbol.
        </p>
        <div class="row">
          <button id="btn-login"    type="button">Login</button>
          <button id="btn-register" type="button">Register</button>
        </div>
        <div id="auth-err" class="err"></div>
      </form>
    </div>
  `;
  const u = host.querySelector<HTMLInputElement>("#u")!;
  const p = host.querySelector<HTMLInputElement>("#p")!;
  const pc = host.querySelector<HTMLInputElement>("#pc")!;
  const e = host.querySelector<HTMLInputElement>("#e")!;
  const confirmRow = host.querySelector<HTMLElement>("#confirm-row")!;
  const policyHint = host.querySelector<HTMLElement>("#pw-policy")!;
  const errDiv = host.querySelector<HTMLElement>("#auth-err")!;

  const showError = (msg: string) => { errDiv.textContent = msg; errDiv.style.display = "block"; };
  const clearError = () => { errDiv.textContent = ""; errDiv.style.display = "none"; };

  // Show confirm field + policy when user clicks Register (not Login)
  let registering = false;

  host.querySelector("#btn-login")!.addEventListener("click", () => {
    clearError();
    if (!u.value || !p.value) return showError("Username and password required.");
    net.send({ t: "login", username: u.value.trim(), password: p.value });
  });

  host.querySelector("#btn-register")!.addEventListener("click", () => {
    clearError();
    if (!registering) {
      // First click: show confirm field + policy hint
      registering = true;
      confirmRow.style.display = "";
      policyHint.style.display = "";
      pc.focus();
      return;
    }
    // Second click: validate and submit
    if (!u.value.trim()) return showError("Username required.");
    if (u.value.trim().length < 3) return showError("Username must be at least 3 characters.");
    if (u.value.trim().length > 24) return showError("Username must be 24 characters or less.");
    if (!/^[a-zA-Z0-9_]+$/.test(u.value.trim())) return showError("Username: letters, numbers, and underscores only.");
    if (!p.value) return showError("Password required.");
    if (p.value.length < 8) return showError("Password must be at least 8 characters.");
    if (!/[a-zA-Z]/.test(p.value)) return showError("Password must contain at least one letter.");
    if (!/[0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(p.value)) return showError("Password must contain at least one number or symbol.");
    if (p.value === u.value.trim()) return showError("Password cannot be the same as username.");
    if (p.value !== pc.value) return showError("Passwords do not match.");
    net.send({ t: "register", username: u.value.trim(), password: p.value, password_confirm: pc.value, email: e.value.trim() || undefined });
  });

  u.focus();
}
